/**
 * Created by ws7s 2017/3/20.
 */


import * as diskConst from './constants';


export default {
    [diskConst.getDisks](state, list) {
        state.list = list.LocalVolumeSet;
        state.total = list.LocalVolumeCount
    },
    [diskConst.describeEbsVolumes](state, list) {
        // console.log(state,list)
        // state.list = list.LocalVolumeSet;
        // state.total = list.LocalVolumeCount
    }
};
